// @ts-nocheck
/* eslint-disable */
import { createReducer } from 'reduxsauce';
import produce from 'immer';
import { Types } from '../actions/cost_center';

const initialState = {
  showCostCenterDrawer: false,
  formFields: {
    name: '',
    description: '',
    code: '',
    id: '',
    default: false,
  },

  confirmationModal: {
    show: false,
    type: 'Cost Centre',
    id: null,
  },
  searchText: '',
  pagination: {
    totalPages: null,
    total: null,
    perPage: 25,
    pageNumber: 1,
  },
  cost_center_ss: [],
  success: false,
};

const openCostCenterDrawer = (state) => ({
  ...state,
  showCostCenterDrawer: true,
});

const closeCostCenterDrawer = (state) => ({
  ...state,
  showCostCenterDrawer: false,
});

const resetFormFields = (state) => ({
  ...state,
  formFields: initialState.formFields,
});

const updateFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;

  return {
    ...state,
    formFields: {
      ...state.formFields,
      [name]: value,
    },
  };
};

const createCostCenterSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data) {
    return {
      ...state,
      cost_center_ss: produce(state.cost_center_ss, (draft) => {
        draft.push(data);
      }),
    };
  }
  return {
    ...state,
    cost_center_ss: [...state.cost_center_ss, data],
  };
};

const getCostCenterSuccess = (state, action) => {
  const {
    payload: { data, total_pages, total, per_page, current_page },
  } = action;
  return {
    ...state,
    cost_center_ss: data,
    pagination: {
      ...state.pagination,
      totalPages: total_pages,
      // perPage: per_page || 25,
      total: total,
      // pageNumber: current_page || 1,
    },
    success: true,
  };
};

const editCostCenter = (state, action) => ({
  ...state,
  formFields: { ...action.payload },
  showCostCenterDrawer: true,
});

const updateCostCenterSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  return {
    ...state,
    cost_center_ss: produce(state.cost_center_ss, (draft) => {
      const index = draft.findIndex((CostCenter) => CostCenter.id === data.id);
      const resetDefault = draft?.find(
        (costCentre) => costCentre?.default === true,
      );
      draft?.splice(
        draft?.findIndex((costCentre) => costCentre?.default === true),
        1,
        { ...resetDefault, default: false },
      );
      draft?.splice(index, 1, data);
    }),
  };
};

const deleteCostCenterSuccess = (state, action) => {
  const {
    payload: { id },
  } = action;

  return {
    ...state,
    cost_center_ss: state.cost_center_ss.filter(
      (CostCenter) => CostCenter.id !== id,
    ),
  };
};

const openConfirmationModal = (state, action) => {
  const {
    payload: { type, id },
  } = action;
  return {
    ...state,
    confirmationModal: {
      show: true,
      type,
      id,
    },
  };
};

const closeConfirmationModal = (state) => ({
  ...state,
  confirmationModal: initialState.confirmationModal,
});

const updateSearch = (state, action) => {
  const {
    payload: { searchText },
  } = action;
  return {
    ...state,
    searchText,
  };
};

const updatePageNumber = (state, action) => {
  const {
    payload: { pageNumber },
  } = action;
  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageNumber,
    },
  };
};

const updatePerPage = (state, action) => {
  const clonedPagination = { ...state.pagination };

  clonedPagination.perPage = action.payload.perPage;
  if (
    clonedPagination.perPage >= clonedPagination.total ||
    clonedPagination.pageNumber >= clonedPagination.totalPages
  ) {
    clonedPagination.pageNumber = 1;
  }

  return {
    ...state,
    pagination: clonedPagination,
  };
};

const costCenterReducer = createReducer(initialState, {
  [Types.OPEN_COST_CENTER_DRAWER]: openCostCenterDrawer,
  [Types.CLOSE_COST_CENTER_DRAWER]: closeCostCenterDrawer,
  [Types.RESET_FORM_FIELDS]: resetFormFields,
  [Types.UPDATE_FORM_FIELD]: updateFormField,
  [Types.CREATE_COST_CENTER_SUCCESS]: createCostCenterSuccess,
  [Types.GET_COST_CENTER_SUCCESS]: getCostCenterSuccess,
  [Types.EDIT_COST_CENTER]: editCostCenter,
  [Types.UPDATE_COST_CENTER_SUCCESS]: updateCostCenterSuccess,
  [Types.DELETE_COST_CENTER_SUCCESS]: deleteCostCenterSuccess,
  [Types.OPEN_CONFIRMATION_MODAL]: openConfirmationModal,
  [Types.CLOSE_CONFIRMATION_MODAL]: closeConfirmationModal,
  [Types.UPDATE_SEARCH]: updateSearch,
  [Types.UPDATE_PAGE_NUMBER]: updatePageNumber,
  [Types.UPDATE_PER_PAGE]: updatePerPage,
});

export default costCenterReducer;
